<template>
  <canvas id="graph-loads-per-day-scheduled" height="120"></canvas>
</template>

<script>
  import { chain, max, values } from 'lodash'
  import { mapActions } from 'vuex'
  import Chart from 'chart.js'

  export default {
    data () {
      return {
        chart: null,
        loads: []
      }
    },

    created () {
      this.getScheduledLoadsGraph()
        .then((response) => {
          this.loads = response.data
        })
        .then(this.initializeGraph)
    },

    methods: {
      ...mapActions('dashboard', ['getScheduledLoadsGraph']),

      initializeGraph () {
        if (this.chart) {
          this.chart.destroy()
        }

        this.chart = new Chart(this.$el.getContext('2d'), {
          type: 'line',
          data: {
            labels: chain(this.loads).keys().value(),
            datasets: [
              {
                label: 'Loads',
                backgroundColor: 'rgba(54,220,227,0.5)',
                borderColor: 'rgba(54,220,227,1)',
                pointBackgroundColor: 'rgba(54,220,227,1)',
                pointBorderColor: '#fff',
                data: chain(this.loads).values().value()
              }
            ]
          },
          options: {
            responsive: true,
            legend: {
              onClick: (e) => e.stopPropagation()
            },
            scales: {
              xAxes: [{
                scaleLabel: {
                  display: true,
                  labelString: 'Day #'
                },
                ticks: {
                  callback (value, index, values) {
                    return parseInt(value) === 1
                      ? value
                      : (parseInt(value) % 5 === 0 ? value : '')
                  }
                }
              }],
              yAxes: [{
                scaleLabel: {
                  display: false,
                  labelString: '# of Loads'
                },
                ticks: {
                  beginAtZero: true,
                  max: max(values(this.loads)) + 1
                }
              }]
            }
          }
        })
      }
    },

    beforeDestroy () {
      if (this.chart) {
        this.chart.destroy()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ScheduledLoadsGraph.vue?14b1c7c4